import React from "react";
import Navbar from "../navbar/Navbar";
import Header from "../header/Header";
import Features from "../features/Features";
import Services from "../services/Services";
import Faq from "../faq/Faq";
import Downloads from "../downloads/Downloads";
import Footer from "../footer/Footer";

const Home = () => {
  return (
    <>
      <Navbar />
      <Header />
      <Features />
      <Services />
      <Faq />
      <Downloads />
      <Footer />
    </>
  );
};

export default Home;
